import { Checkbox, FormControlLabel, createTheme } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { checkBoxStyle } from 'assets/jss/jss'
import PropTypes from 'prop-types'
import { GridItem } from '..'

const useStyles = makeStyles(checkBoxStyle)

const CheckBoxFormik = props => {
  const classes = useStyles()
  const {
    formik,
    label,
    checked,
    name,
    color,
    error,
    success,
    blanco,
    onChange,
    sm,
    md,
    labelPlacement,
    disabled,
    isCheckedVal = null,
    setIsChecked = null
  } = props

  const handleChange = event => {
    formik.setFieldValue(name, event.target.checked)
    if (setIsChecked) {
      setIsChecked(!isCheckedVal)
    }
  }
  
  return (
    <GridItem xs={12} sm={sm === null ? 12 : sm} md={md}>
      <ThemeProvider theme={theme}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={disabled}
              checked={checked}
              onChange={handleChange}
              name={name}
              color={color}
             
            />
          }
          labelPlacement={labelPlacement || 'start'}
          label={label}
        />
      </ThemeProvider>
    </GridItem>
  )
}

export default CheckBoxFormik

CheckBoxFormik.propTypes = {
  formik: PropTypes.object,
  open: PropTypes.bool,
  label: PropTypes.string,
  checked: PropTypes.bool,
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  blanco: PropTypes.bool,
  onChange: PropTypes.func,
  sm: PropTypes.number,
  md: PropTypes.number,
  labelPlacement: PropTypes.string,
  disabled: PropTypes.bool
}

export const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 'small !important',
          marginRight: '10px'
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: '0'
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          padding: '0px !important'
        },
        label: {
          fontSize: '0.850rem'
        }
      }
    }
  }
})
